import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyAk9AVMAR76MkFOW5aQz9IBZlzdc-E7Ct8",
    authDomain: "onlive-poker-dev.firebaseapp.com",
    databaseURL: "https://onlive-poker-dev.firebaseio.com",
    projectId: "onlive-poker-dev",
    storageBucket: "onlive-poker-dev.appspot.com",
    messagingSenderId: "993697548757",
    appId: "1:993697548757:web:2f75c22118843cdf90155c",
    measurementId: "G-8KHP8J7X3Z"
};

firebase.initializeApp(firebaseConfig);

export const storage = firebase.storage().ref('CasinoStaffProfiles/')
export const exportHandFunction = firebase.functions().httpsCallable('onExportHandHistory')

export default firebase